import { Link } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";
import { pillarArticles } from "@/data/articles";

export default function ArticleGrid() {
  const { currentLang } = useLanguage();

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {pillarArticles.map((article) => (
        <Link
          key={article.slug}
          to={`/${currentLang}/article/${article.slug}`}
          className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition hover:-translate-y-0.5 hover:border-primary-300"
        >
          <div className="relative h-44 w-full overflow-hidden">
            <img
              src={article.image}
              alt={article.title[currentLang]}
              className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
            />
          </div>
          <div className="flex flex-1 flex-col p-5">
            <h3 className="text-base font-semibold leading-snug text-foreground-950">
              {article.title[currentLang]}
            </h3>
            <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">
              {article.summary[currentLang]}
            </p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
              Read article
              <i className="ri-arrow-right-line transition group-hover:translate-x-0.5"></i>
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}